export enum USER_ROLE {
  notLogged = 'not-logged',
  subscriptionRenewal = 'subscription-renewal',
  subscribedUser = 'subscribed-user',
  subscriptionPending = 'subscription-pending',
  noRole = 'no-role',
}
